import expandRange from './expandRange';

// if cursor is 'f|oo', expand to '|foo|'
export default function expandRangeToWord(range, value) {
  if (range.start === range.end) {
    expandRange(range, value, /[\s]/);
  }
}
